import { useState, useRef, useEffect } from 'react';
import './Terminal.css';

function Terminal() {
    const [history, setHistory] = useState([
        { type: 'output', text: 'NeuAIs Terminal v1.0.0' },
        { type: 'output', text: 'Type "help" for available commands' },
    ]);
    const [input, setInput] = useState('');
    const terminalRef = useRef(null);
    const inputRef = useRef(null);

    useEffect(() => {
        if (terminalRef.current) {
            terminalRef.current.scrollTop = terminalRef.current.scrollHeight;
        }
    }, [history]);

    const executeCommand = (cmd) => {
        const trimmedCmd = cmd.trim();

        if (!trimmedCmd) return;

        // Add command to history
        setHistory((prev) => [...prev, { type: 'command', text: `$ ${trimmedCmd}` }]);

        // Process command
        let output = '';

        switch (trimmedCmd.toLowerCase()) {
            case 'help':
                output = `Available commands:
  help     - Show this help message
  clear    - Clear terminal
  ls       - List files
  pwd      - Print working directory
  date     - Show current date and time
  echo     - Echo a message`;
                break;
            case 'clear':
                setHistory([]);
                return;
            case 'ls':
                output = 'main.py    utils.js    config.json    README.md';
                break;
            case 'pwd':
                output = '/workspace/project';
                break;
            case 'date':
                output = new Date().toString();
                break;
            default:
                if (trimmedCmd.startsWith('echo ')) {
                    output = trimmedCmd.substring(5);
                } else {
                    output = `Command not found: ${trimmedCmd}. Type "help" for available commands.`;
                }
        }

        if (output) {
            setHistory((prev) => [...prev, { type: 'output', text: output }]);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            executeCommand(input);
            setInput('');
        }
    };

    const handleTerminalClick = () => {
        inputRef.current?.focus();
    };

    return (
        <div className="terminal" onClick={handleTerminalClick}>
            <div className="terminal-header">
                <span className="terminal-title">TERMINAL</span>
                <div className="terminal-controls">
                    <button
                        className="terminal-btn"
                        onClick={(e) => {
                            e.stopPropagation();
                            setHistory([
                                { type: 'output', text: 'NeuAIs Terminal v1.0.0' },
                                { type: 'output', text: 'Type "help" for available commands' },
                            ]);
                        }}
                        title="Clear"
                    >
                        <img src="/svg/cross.svg" alt="Clear" style={{ width: '12px', height: '12px' }} />
                    </button>
                </div>
            </div>
            <div className="terminal-content" ref={terminalRef}>
                {history.map((entry, index) => (
                    <div key={index} className={`terminal-line ${entry.type}`}>
                        {entry.text.split('\n').map((line, i) => (
                            <div key={i}>{line}</div>
                        ))}
                    </div>
                ))}
                <div className="terminal-input-line">
                    <span className="terminal-prompt">$</span>
                    <input
                        ref={inputRef}
                        type="text"
                        className="terminal-input"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onKeyDown={handleKeyDown}
                        autoFocus
                    />
                </div>
            </div>
        </div>
    );
}

export default Terminal;
